import React, { useState, useEffect, useCallback } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Productlist from "./Productlist";
import Productgrid from "./Productgrid";
import Select from "react-select";
import { Tabs, Tab, Modal, Nav } from "react-bootstrap";
import {
  getAllProductDetailslist,
  getInvoiceSupplierList,
  // getSegmentList,
  getUnspcAdd,
  getActiveProduct,
  getFamilyList,
  getClassList,
  getCommodityUnspcList,
  updateBaseQty,
  addUnspscData,
} from "../../../service/Product/ProductService";
import {
  deleteSegment,
  getAddSegment,
  getAddSegmentToAll,
  getSegmentAdd,
  getSegmentList,
  getSegmentUnspcAdd,
  getFamilyUnspcAdd,
  getClassUnspcAdd,
} from "../../../service/Segment/SegmentService";
import { Card, Tooltip, OverlayTrigger, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Checkbox from "../../components/Checkbox";
import moment from "moment";
import Multiselect from "../Multiselect";
import {
  searchUnspc,
  getSelectedUnspscDetails,
} from "../../../service/Segment/SegmentService";
import ReactPaginate from "react-paginate";
import SpinnerComponent from "../../components/SpinnerComponent";
import { Country } from "country-state-city";
import { CSVLink } from "react-csv";
import Papa from "papaparse";
import instance from "../../../WebApi/WebApi";
import { useTranslation } from "react-i18next";
import useUnitData from "./UnitData";
import debounce from "lodash/debounce";
import "./Products.css";

const TreeItem = ({ title, children, onClick, isOpen, toggleOpen }) => {
  return (
    <div style={{ marginLeft: "20px" }}>
      <div style={{ display: "flex", margin: "5px" }}>
        <div
          onClick={toggleOpen}
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          {!title.startsWith("Commodity Code") && (
            <span style={{ marginRight: "5px" }}>{isOpen ? "−" : "+"}</span>
          )}
          {title}
        </div>
      </div>

      {isOpen && <div>{children}</div>}
    </div>
  );
};

const Products = () => {
  //Search
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalSearchResult, setTotalSearchResult] = useState(0);
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchResultsEnd, setSearchResultsEnd] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [selectedSearchResult, setSelectedSearchResult] = useState("");

  const { t } = useTranslation();

  const navigate = useNavigate();
  const unitData = useUnitData();
  const [logs, setLogs] = useState(false);
  let countryData = Country.getAllCountries();
  const [isToggled, setToggled] = useState(true);
  const [isToggleddata, setToggleddata] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  // const [toggleCo2,setToggleCo2] = useState(true);
  const [allLogs, setAllLogs] = useState();
  const [co2Modal, setCO2Modal] = useState(false);
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [co2Id, setCO2Id] = useState("");
  const [selectedCO2All, setSelectedCO2All] = useState(false);
  const [co2Info, setCO2Info] = useState({});
  const [baseInfo, setBaseInfo] = useState({});
  const [baseUnitModal, setBaseUnitModal] = useState(false);

  const [openSegment, setOpenSegment] = useState(null);
  const [openFamily, setOpenFamily] = useState(null);
  const [openClass, setOpenClass] = useState(null);

  const handleSegmentClick = (segment) => {
    setOpenSegment(openSegment === segment ? null : segment);
    if (onDataSegment) onDataSegment(segment);
  };

  const handleFamilyClick = (segment, family) => {
    setOpenFamily(openFamily === family ? null : family);
    setOpenClass(null); // Close all classes when a new family is opened
    if (onDataFamily) onDataFamily(family);
  };

  const handleClassClick = (family, classItem) => {
    setOpenClass(openClass === classItem ? null : classItem);
    if (onDataClass) onDataClass(classItem);
  };

  const handleToggle = () => {
    setToggled(!isToggled);
  };
  const handleCloseCo2Modal = () => setCO2Modal(false);
  const handleCloseBaseModal = () => setBaseUnitModal(false);

  const handleToggledata = () => {
    setToggleddata(!isToggleddata);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      !isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  const afterUpdateUnspschandledata = () => {
    // setToggleddata(!isToggleddata);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const [isActive, setActive] = useState("false");
  const [getProductId, setProductId] = useState([]);
  const [invoiceSupplierDataList, setAllInvoiceSupplierDataList] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [vat, setVat] = useState("");
  const [month, setMonth] = useState("");
  const [showUnspc, setShowUnspc] = useState(false);
  const [getSegmentCode, setGetSegmentCode] = useState([]);
  const [allAllDataList, setAllDataList] = useState([]);
  const [segmentCode, setSegmentCode] = useState("");
  const [addProductId, setAddProductId] = useState("");
  const [selected, setSelected] = useState([]);
  const [selectedUnspsc, setSelectedUnspsc] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedCO2, setSelectedCO2] = useState([]);

  const [allUnspcList, setAllUnspcList] = useState([]);
  const [familyList, setFamilyList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [commodityList, setCommodityList] = useState([]);

  const [segmentData, setSegmentData] = useState({});
  const [familyData, setFamilyData] = useState({});
  const [classData, setClassData] = useState({});
  const [commodityData, setCommodityData] = useState({});

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [finalStartDate, setFinalStartDate] = useState("");
  const [finalEndDate, setFinalEndDate] = useState("");
  const [segmentDataList, setAllSegmentDataList] = useState([]);
  const [getDataSegment, setDataSegment] = useState("");
  const [allUnspcFamily, setUnspcFamily] = useState([]);
  const [allUnspcClass, setUnspcClass] = useState([]);
  const [allUnspcComodity, setUnspcComodity] = useState([]);
  const [getDataFamily, setDataFamily] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [activeTab, setActiveTab] = useState("tab1");
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [selectedProductDetails, setSelectedProductDetails] = useState({});
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [selectedPastOrderDetails, setSelectedPastOrderDetails] = useState({});

  const PER_PAGE = 10;

  const currencyFormatter = require("currency-formatter");

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * PER_PAGE;
  const currentPageData = getProductId.slice(offset, offset + PER_PAGE);

  const pageCount = Math.ceil(getProductId?.length / PER_PAGE);

  const handleClose = () => {
    setShow(false);
  };
  const handleCloseUnspc = () => {
    setFamilyList([]);
    setClassList([]);
    setCommodityList([]);
    setSegmentData({});
    setFamilyData({});
    setClassData({});
    setCommodityData({});
    setShowUnspc(false);
    setSelected([]);
    setSelectedAll(false);
  };
  const handleCloseLogs = () => setLogs(false);

  const searchPage = () => {
    // navigate("/search-all-unspsc");
    navigate("/search-all-unspsc", { state: { selected } });
  };

  useEffect(() => {
    getallProductList();
    getInvoiceSupplierDataList();
    getSegmentAddList();
  }, []);

  const handleActive = (id, isActive) => {
    setIsLoading(true);
    getActiveProduct("Product", id, isActive ? false : true, (r) => {
      if (r.success === true) {
        getallProductList();
        setIsLoading(false);
      } else {
        setIsLoading(false);
        // toast.error(r.message)
      }
    });
  };

  async function getSegmentAddList() {
    setIsLoading(true);
    getSegmentList().then(function (result) {
      const response = result.data;
      setAllUnspcList(
        response?.data?.segmentList.map((item) => {
          return { id: item.id, value: item.Segment, label: item.SegmentTitle };
        })
      );
      setAllSegmentDataList(response?.data?.segmentList);
      setIsLoading(false);
    });
  }

  async function getallProductList() {
    setIsLoading(true);
    getAllProductDetailslist("").then(function (result) {
      const response = result.data;
      // console.log(response, "response");
      setProductId(response?.data?.listProduct);
      setIsLoading(false);
      //  console.log(response?.data?.listProduct.length, "papu");
      // setDepartmentId(response?.data?.businessUnit?.Departments);
    });
  }

  async function getInvoiceSupplierDataList() {
    setIsLoading(true);
    getInvoiceSupplierList().then(function (result) {
      const response = result?.data;
      setAllInvoiceSupplierDataList(response?.data?.SuppliersList);
      setIsLoading(false);
    });
  }

  const onSuppliers = (e) => {
    setIsLoading(true);
    const ArrSup = e ? e : [];
    supplier.push(e);
    setSupplier(supplier);

    getAllProductDetailslist(
      ArrSup,
      vat,
      month,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
      setIsLoading(false);
    });
  };

  const onVat = (e) => {
    setVat(e.target.value);
    getAllProductDetailslist(
      supplier,
      e.target.value,
      month,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  const onMonth = (e) => {
    setIsLoading(true);
    setMonth(Number(e.target.value ? e.target.value : 12));
    getAllProductDetailslist(
      supplier,
      vat,
      e.target.value ? Number(e.target.value) : 12,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
      setIsLoading(false);
    });
  };

  const onSearch = (e) => {
    setIsLoading(true);
    setSearch(e.target.value);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      e.target.value,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
      setIsLoading(false);
    });
  };

  const onUnspc = (e, data = "", index) => {
    e.preventDefault();
    setShowUnspc(true);
    if (data) {
      setSelected([data]);
    }
  };

  const onCo2All = (e, data = "") => {
    e.preventDefault();
    setCO2Modal(true);
    if (data) {
      setSelectedCO2([data]);
    }
  };

  const onSegment = (e, index) => {
    // {value: 10000000, label: 'Live Plant and Animal Material and Accessories and Supplies'}
    setSegmentCode(e.target.value);
    const segmentfilterData = allUnspcList.filter(
      (item) => item.Segment === Number(e.target.value)
    );
    setGetSegmentCode(segmentfilterData[0]?.SegmentTitle);
    // getAddSegmentToAll(e.target.value).then(function (result) {
    //   const response = result.data;
    //   setAllDataList(response?.data);
    // });
  };

  const onAddUnspc = (e) => {
    e.preventDefault();
    // console.log(selected)
    if (commodityData.value) {
      getUnspcAdd(
        commodityData,
        // commodityData.label,
        selected,
        "Commodity",
        (r) => {
          if (r.success === true) {
            toast.success(r.message);
            setShowUnspc(false);
            setSegmentCode("");
            afterUpdateUnspschandledata();
          } else {
            toast.error(r.message);
          }
        }
      );

      // for (const iterator of selected) {
      //     unspscPayload.push({productId:iterator.id,unspsc:commodityData.value,point:'commodity'});
      // }
    } else if (classData.value) {
      getUnspcAdd(classData, selected, "Class", (r) => {
        if (r.success === true) {
          toast.success(r.message);
          setShowUnspc(false);
          setSegmentCode("");
          afterUpdateUnspschandledata();
        } else {
          toast.error(r.message);
        }
      });
    } else if (familyData.value) {
      getUnspcAdd(familyData, selected, "Family", (r) => {
        if (r.success === true) {
          toast.success(r.message);
          setShowUnspc(false);
          setSegmentCode("");
          afterUpdateUnspschandledata();
        } else {
          toast.error(r.message);
        }
      });
    } else if (segmentData.value) {
      getUnspcAdd(segmentData, selected, "Segment", (r) => {
        if (r.success === true) {
          toast.success(r.message);
          setShowUnspc(false);
          setSegmentCode("");
          afterUpdateUnspschandledata();
        } else {
          toast.error(r.message);
        }
      });
    } else {
      toast.error("Please select at least one unspsc");
    }

    setFamilyList([]);
    setClassList([]);
    setCommodityList([]);
    setSegmentData({});
    setFamilyData({});
    setClassData({});
    setCommodityData({});
    setShowUnspc(false);
  };

  const onRemoveUnspc = (e) => {
    e.preventDefault();
    if (classData.value) {
      setClassData({});
      setCommodityData({});
    } else if (familyData.value) {
      setFamilyData({});
    } else if (segmentData.value) {
      setSegmentData({});
    }
  };

  function handleSelect(value, name) {
    // console.log(value)
    // console.log(name)
    // if (value) {
    //   setSelected([...selected, name]);
    // } else {
    //   setSelected(selected.filter((item) => item !== name));
    // }
    selected.some((item) => item.id === name.id)
      ? setSelected(selected.filter((item) => item !== name))
      : setSelected([...selected, name]);
  }

  function selectAll(e) {
    if (e.target.checked) {
      const filterData = getProductId.filter((data) => data?.isActive);

      setSelectedAll(true);
      setSelected(filterData);
    } else {
      setSelectedAll(false);
      setSelected([]);
    }
  }

  const onFromDate = (e) => {
    setIsLoading(true);
    setStartDate(e);
    // console.log(e, "eeeeeeeeeeeeeee")
    const fromDate = moment(e).format("YYYY-MM-DD");
    // console.log(fromDate, "fromDate");
    setFinalStartDate(fromDate);
    // setSearch(e.target.value);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      isToggleddata,
      fromDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
      setIsLoading(false);
    });
  };

  const onToDate = (e) => {
    setIsLoading(true);
    setEndDate(e);
    const toDate = moment(e).format("YYYY-MM-DD");
    setFinalEndDate(toDate);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      isToggleddata,
      finalStartDate,
      toDate
    ).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
      setIsLoading(false);
    });
  };

  const _RESET = (e) => {
    setIsLoading(true);
    e.preventDefault();
    setSearch("");
    // setBusinessUnit("");
    setSupplier([]);
    setFinalStartDate("");
    setFinalEndDate("");
    setStartDate("");
    setEndDate("");
    setMonth("");
    setVat("");
    setToggleddata(false);
    setSelectedOptions([]);
    getAllProductDetailslist("", "", "", false, false, "", "").then(function (
      result
    ) {
      const response = result?.data;
      // console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
      setIsLoading(false);
    });
  };

  const [qtyData, setQtyData] = useState({
    productId: null,
    BaseQuantity: "",
  });

  const _UPDATE_VALUE = (e, d) => {
    e.preventDefault();
    setQtyData({ productId: d.id, BaseQuantity: e.target.value });
  };

  const _SAVE_QTY = (e, d) => {
    setIsLoading(true);
    e.preventDefault();
    if (d.id === qtyData.productId) {
      updateBaseQty(qtyData, (res) => {
        getallProductList();
        toast.success(res.message);
      });
    } else {
      updateBaseQty(
        { productId: d.id, BaseQuantity: d?.item?.InvoicedQuantity?._text },
        (res) => {
          getallProductList();
          setIsLoading(false);
          toast.success(res.message);
        }
      );
    }
  };

  // Function to convert the array of objects
  function convertToArrayOfObjects_OLD(array) {
    const result = [];
    for (let index = 0; index < array.length; index++) {
      result.push({
        value: {
          code: array[index].Segment.Segment,
          point: "Segment",
          title: array[index].Segment.SegmentTitle,
          id: array[index].Segment.id,
        },
        label: `${array[index].Segment.SegmentTitle} ( Segment - ${array[index].Segment.Segment})`,
      });
      result.push({
        value: {
          code: array[index].Family.Family,
          point: "Family",
          title: array[index].Family.FamilyTitle,
          id: array[index].Family.id,
        },
        label: `${array[index].Family.FamilyTitle} ( Family - ${array[index].Family.Family})`,
      });
      result.push({
        value: {
          code: array[index].Class.Class,
          point: "Class",
          title: array[index].Class.ClassTitle,
          id: array[index].Class.id,
        },
        label: `${array[index].Class.ClassTitle} ( Class - ${array[index].Class.Class})`,
      });
      result.push({
        value: {
          code: array[index].Commodity.Commodity,
          point: "Commodity",
          title: array[index].Commodity.CommodityTitle,
          id: array[index].Commodity.id,
        },
        label: `${array[index].Commodity.CommodityTitle} ( Commodity - ${array[index].Commodity.Commodity})`,
      });
    }
    let jsonObject = result.map(JSON.stringify);
    let uniqueSet = new Set(result.map(JSON.stringify));
    let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
    // console.log(uniqueArray,"res1")
    setSearchResults(uniqueArray.filter((item) => item.value !== null));
    setIsLoading(false);
    // return uniqueArray;
  }

  function convertToArrayOfObjects(response, searchKey) {
    const options = [];

    response.forEach((item) => {
      if (item.SegmentTitle.toLowerCase().includes(searchKey.toLowerCase())) {
        options.push({
          label: `${item.SegmentTitle} (Segment - ${item.Segment})`,
        });
      }
      if (item.FamilyTitle.toLowerCase().includes(searchKey.toLowerCase())) {
        options.push({
          label: `${item.FamilyTitle} (Family - ${item.Family})`,
        });
      }
      if (item.ClassTitle.toLowerCase().includes(searchKey.toLowerCase())) {
        options.push({
          label: `${item.ClassTitle} (Class - ${item.Class})`,
        });
      }
      if (item.CommodityTitle.toLowerCase().includes(searchKey.toLowerCase())) {
        options.push({
          label: `${item.CommodityTitle} (Commodity - ${item.Commodity})`,
        });
      }
    });

    return options;
  }

  const _SEARCH_UNSPSC = debounce((data) => {
    if (!data) return;

    setIsSearchLoading(true);
    setSearch(data);

    searchUnspc(data, (res) => {
      if (!res.data || res.data.length === 0) {
        // console.log("No results found");
        setSearchResults(["label:No results found"]);
        // setIsLoading(false);
        setIsSearchLoading(false);

        return;
      }

      // console.log(res.data);
      const formatted_data = convertToArrayOfObjects(res.data, data);
      // console.log(formatted_data);
      setSearchResults(formatted_data); // Update search options
      // setIsLoading(false);
      setIsSearchLoading(false);
    });
  }, 1500);

  const _SELECT_UNSPSC = (data) => {
    // console.log("search Data");
    setIsLoading(true);
    // console.log(data);
    getUnspcAdd(data, selected, (r) => {
      if (r.success === true) {
        toast.success(r.message);
        setShowUnspc(false);
        setSegmentCode("");
        afterUpdateUnspschandledata();
        setIsLoading(false);
        setSelected([]);
        setSelectedAll(false);
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const onDataSegment = (e) => {
    setIsLoading(true);
    // console.log(e, "sesesegegegege")
    setDataSegment(e);
    getSegmentUnspcAdd(e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcFamily(r?.data?.listUnspsc);
        setIsLoading(false);

        // toast.success(r.message)
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const onDataFamily = (e) => {
    setIsLoading(true);
    // console.log(e, "sesesegegegege")
    setDataFamily(e);

    getFamilyUnspcAdd(getDataSegment, e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcClass(r?.data?.listUnspsc);
        setIsLoading(false);

        // toast.success(r.message)
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const onDataClass = (e) => {
    setIsLoading(true);
    // console.log(e, "sesesegegegege")
    setDataFamily(e);

    getClassUnspcAdd(getDataSegment, getDataFamily, e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcComodity(r?.data?.listUnspsc);
        setIsLoading(false);

        // toast.success(r.message)
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const generalTableData = getProductId.map((item) => ({
    id: item?.id,
    supplierName: item?.supplierShortName || "----",
    supplierId: item?.supplierId,
    productNumber: item?.number || "----",
    productName: item?.name || "----",
    UNSPSC:
      item?.type === "Family"
        ? item?.unspscFamily?.FamilyTitle
        : item?.type === "Class"
        ? item?.unspscClass?.ClassTitle
        : item?.type === "Commodity"
        ? item?.unspscCommodity?.CommodityTitle
        : item?.type === "Segment"
        ? item?.unspscSegment?.SegmentTitle
        : "",
    listPrice: item?.salePrice,
    discount: item?.discount,
    purchasePrice:
      Number(
        item?.salePrice - Number(item?.salePrice * item?.discount) / 100
      ) || "----",
    baseUnit: item?.baseUnit || "----",
    purchasePriceBase: Number(item?.baseUnit)
      ? (
          Number(
            item?.salePrice - Number(item?.salePrice * item?.discount) / 100
          ) / Number(item?.baseUnit)
        ).toFixed(2)
      : "----",
    kgco2_co2_unit: item?.kgco2_co2_unit || "----",
    productUpdatedAt: item?.productUpdatedAt || "----",
    isActive: item?.isActive,
  }));
  const UNSPSCTableData = getProductId.map((item) => ({
    id: item?.id,
    supplierName: item?.supplierShortName || "----",
    supplierId: item?.supplierId,
    productNumber: item?.number || "----",
    productName: item?.name || "----",
    UNSPSC:
      item?.type === "Family"
        ? item?.unspscFamily?.FamilyTitle
        : item?.type === "Class"
        ? item?.unspscClass?.ClassTitle
        : item?.type === "Commodity"
        ? item?.unspscCommodity?.CommodityTitle
        : item?.type === "Segment"
        ? item?.unspscSegment?.SegmentTitle
        : "",
    sale_unit_of_measure: item?.sale_unit_of_measure || "----",
    base_unit_of_measure: item?.base_unit_of_measure || "----",
    baseUnitPrice: item?.baseUnit || "----",
    sub_unit_of_measure: item?.sub_unit_of_measure || "----",

    subUnitQty: item?.subUnitQty || "----",
    isActive: item?.isActive,
  }));
  const CO2TableData = getProductId.map((item) => ({
    id: item?.id,
    supplierId: item?.supplierId,
    supplierName: item?.supplierShortName,
    supplierId: item?.supplierId,
    productNumber: item?.number,
    productName: item?.name,
    co2_unt_measure: item?.co2_unt_measure,
    co2_qty: item?.co2_qty,
    kgco2_co2_unit: item?.kgco2_co2_unit,
    KgCO2_per_Sale_unit: item?.KgCO2_per_Sale_unit,
    manufactureName: item?.manufactureName,
    manufactureProductNumber: item?.manufactureProductNumber,

    subUnitQty: item?.subUnitQty,
    country: item?.country,
    isActive: item?.isActive,
  }));

  const generalProductColumn = [
    { label: t("Supplier"), key: "supplierName" },
    { label: t("Product Number"), key: "productNumber" },
    { label: t("Product Name"), key: "productName" },
    { label: t("UNSPSC"), key: "UNSPSC" },
    { label: t("List Price"), key: "listPrice" },
    { label: t("Discount"), key: "discount" },
    { label: t("Purchase Price"), key: "purchasePrice" },
    { label: t("Base unit quantity"), key: "baseUnit" },
    { label: t("Purchase Price Base unit"), key: "purchasePriceBase" },
    { label: t("KgCO2e per CO2e unit"), key: "KgCO2_per_CO2_unit" },
    { label: t("Last modified date"), key: "productUpdatedAt" },
  ];

  const UNSPSCColumn = [
    { label: t("Supplier"), key: "supplierName" },
    { label: t("Product Number"), key: "productNumber" },
    { label: t("Product Name"), key: "productName" },
    { label: t("Sale unit of measure"), key: "sale_unit_of_measure" },
    { label: t("Base unit of measure"), key: "base_unit_of_measure" },
    { label: t("Base unit quantity"), key: "baseUnitPrice" },
    { label: t("Sub unit of measure"), key: "sub_unit_of_measure" },
    { label: t("Sub unit quantity"), key: "subUnitQty" },
    { label: t("UNSPSC"), key: "UNSPSC" },
  ];

  const CO2Column = [
    { label: t("Supplier name"), key: "supplierName" },
    { label: t("Product Number"), key: "productNumber" },
    { label: t("Product Name"), key: "productName" },
    { label: t("CO2e units"), key: "co2_unit" },
    { label: t("CO2e unit quantity"), key: "co2_qty" },
    { label: t("KgCO2e per CO2e unit"), key: "KgCO2_per_co2_unit" },
    { label: t("KgCO2e per Sale unit"), key: "KgCO2_per_sale_unit" },
    { label: t("Manufacturer name"), key: "baseUnitPrice" },
    { label: t("Manufacturer product number"), key: "sub_unit_of_measure" },
    { label: t("Country of origin"), key: "origin" },
  ];

  const getPurchasePrice = (salePrice, discount) => {
    return discount
      ? Number(salePrice) - Number(salePrice) * (Number(discount) / 100)
      : salePrice;
  };

  const onLogs = (e, id) => {
    e.preventDefault();
    getAllLogs(id);
  };
  const onPurchase = (e, id) => {
    e.preventDefault();
    getPurchaseHistory(id);
  };
  const getPurchaseHistory = async (id) => {
    const data = {
      productId: id,
    };
    const response = await instance.post(
      `/customer/product/get-purchase-history-by-id`,
      data
    );
    setPurchaseHistory(response?.data?.data?.purchaseHistories);
    setPurchaseModal(true);
  };

  const getAllLogs = async (id) => {
    const data = {
      productId: id,
    };
    setIsLoading(true);
    try {
      const response = await instance.post(
        `/customer/product/get-product-log`,
        data
      );
      //  console.log("response-->", response);
      if (response?.data?.success) {
        setAllLogs(response?.data?.data?.productLog);
        setLogs(true);
        setIsLoading(false);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
      setIsLoading(false);
    }
  };

  const handleTabSelect = (eventKey) => setActiveTab(eventKey);

  const onCo2 = () => {
    setCO2Modal(true);
  };

  const onCO2Check = (id) => {
    if (id) {
      if (selectedCO2.includes(id)) {
        const filterData = selectedCO2.filter((item) => item !== id);
        //  console.log("ifffff", filterData);
        setSelectedCO2(filterData);
      } else {
        setSelectedCO2([...selectedCO2, id]);
      }
    }
  };
  const onCO2CheckAll = (e) => {
    if (e.target.checked) {
      const filterData = getProductId
        .filter((data) => data?.isActive)
        .map((item) => item?.id);
      setSelectedCO2All(true);
      setSelectedCO2(filterData);
    } else {
      setSelectedCO2All(false);
      setSelectedCO2([]);
    }
  };

  const onUNSPSCCheck = (id) => {
    if (id) {
      if (selected.some((item) => item.id == id.id)) {
        const filterData = selected.filter((item) => item?.id !== id?.id);
        setSelected(filterData);
      } else {
        setSelected([...selected, id]);
      }
    }
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setCO2Info({
      ...co2Info,
      [name]: value,
    });
  };
  const handleChangeInputBase = (e) => {
    const { name, value } = e.target;
    setBaseInfo({
      ...baseInfo,
      [name]: value,
    });
  };

  const onBaseUnit = (e) => {
    e.preventDefault();
    setBaseUnitModal(true);
  };
  const handleUpdateCo2 = async () => {
    const productIds = selectedCO2.map((d) => ({ id: d }));
    const data = {
      products: productIds,
      co2_qty: co2Info?.co2_qty,
      co2_unt_measure: co2Info?.co2_unt_measure,
      kgco2_co2_unit: co2Info?.kgco2_co2_unit,
    };
    try {
      const response = await instance.post(
        `/customer/product/edit-co2-for-product`,
        data
      );
      //  console.log("response----->", response);
      handleCloseCo2Modal();
      setSelectedCO2([]);
      getallProductList();
    } catch (err) {
      //  console.log(err);
    }
  };
  const handleUpdateBase = async () => {
    const productIds = selected.map((d) => ({ id: d?.id }));
    const data = {
      products: productIds,
      baseUnit: baseInfo?.baseUnit,
      base_unit_of_measure: baseInfo?.base_unit_of_measure,
      subUnitQty: baseInfo?.subUnitQty,
      sub_unit_of_measure: baseInfo?.sub_unit_of_measure,
    };
    try {
      const response = await instance.post(
        `/customer/product/edit-co2-for-product`,
        data
      );
      //  console.log("response----->", response);
      handleCloseBaseModal();
      setSelected([]);
      getallProductList();
    } catch (err) {
      //  console.log(err);
    }
  };
  // console.log("selectedCO2", selectedCO2);

  const handleCountry = async (con, id) => {
    const data = {
      country: con,
      productId: id,
    };
    await instance.post(`/customer/product/edit-product`, data);
    getallProductList();
  };

  // Search Section
  const searchUnspsc = debounce((input) => {
    setSearch("");
    setPage(1);
    setTotalSearchResult(0);
    setSearchResults([]);

    if (!input) {
      return;
    }

    setSearch(input);
  }, 1500);

  const loadMoreResults = () => {
    setPage(page + 1);
  };

  function getSearchResults() {
    setIsSearchLoading(true);

    searchUnspc(search, page, "user", (res) => {
      if (!res.data || res.data.results.length === 0) {
        setSearchResults([]);
        setIsSearchLoading(false);
        return;
      }

      setSearchResults((prevResults) => [...prevResults, ...res.data.results]);
      setTotalSearchResult(res.data.total);
      setSearchResultsEnd(res.data.reachedEnd);
      setIsSearchLoading(false);
    });
  }

  function getUnspscData(result) {
    toast.dismiss();

    toast.warning(
      <div className="toast-content">
        <div className="toast-message">
          Are you sure you want to add this UNSPSC?
        </div>
        <div className="button-container">
          <button
            className="yes-button"
            onClick={() => {
              // Proceed with the function if "Yes" is clicked
              getSelectedUnspscDetails(result, (res) => {
                if (res.success) {
                  addUnspscData(res.data.details, selected, (r) => {
                    if (r.success === true) {
                      toast.success(r.message);
                      setPage(1);
                      setSearchResults([]);
                      setSearch("");
                      handleCloseUnspc();
                      afterUpdateUnspschandledata();
                    } else {
                      toast.error(r.message);
                    }
                  });
                }
              });
            }}
          >
            Yes
          </button>
          <button
            className="no-button ms-2"
            onClick={() => {
              // Dismiss the toast if "No" is clicked
              toast.dismiss();
            }}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: true, // Keep the toast open until user interacts
        closeOnClick: true, // Prevent closing the toast on click
      }
    );
  }

  useEffect(() => {
    getSearchResults();
  }, [search]);

  useEffect(() => {
    if (page > 1) {
      getSearchResults();
    }
  }, [page]);

  const getPurchaseHistoryByProductId = async (product_id) => {
    console.log("product_id", product_id);

    const response = await instance.get(
      `/customer/product/get-product-details-by-id?productId=${product_id}`
    );

    if (response?.data?.status != 200) {
      toast.error("Purchase History not found!");
      // console.log("response", response);
    } else {
      console.log("response", response);
      // console.log("response", response?.data?.data);
      // console.log("response", response?.data?.data?.getProductDetails);
      setPurchaseHistory(response?.data?.data?.purchaseHistories);
      setSelectedProductDetails(response?.data?.data?.productDetails);
      setSelectedInvoiceId(response?.data?.data?.invoice_id);
      setSelectedPastOrderDetails(response?.data?.data?.pastOrder);
      setShowPurchaseModal(true);
    }
  };

  return (
    <div className="container-fluid">
      <div className="dbMain prdtsbg">
        <Leftpanel breadcm="Product" />
        <div className="dbRight">
          <Header
            link="/dashboard"
            breadcm=""
            title={t("products")}
            description=""
          />
          <Modal
            size="lg"
            show={baseUnitModal}
            onHide={handleCloseBaseModal}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h5 className="mb-0">{t("add")} Base Unit Information</h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-md-6 mt">
                  {" "}
                  <label>Base Unit</label>
                  <select
                    className="form-control"
                    name="base_unit_of_measure"
                    onChange={(e) => handleChangeInputBase(e)}
                  >
                    <option value="">Select</option>

                    {unitData?.map((data, index) => (
                      <option key={index} value={data.common_unit}>
                        {data.common_unit}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 mt">
                  <label>Base Unit Quantity</label>
                  <input
                    type="text"
                    className="form-control"
                    name="baseUnit"
                    onChange={(e) => handleChangeInputBase(e)}
                  />
                </div>
                <div className="col-md-6 mt">
                  {" "}
                  <label>Sub Unit</label>
                  <select
                    className="form-control"
                    name="sub_unit_of_measure"
                    onChange={(e) => handleChangeInputBase(e)}
                  >
                    <option value="">Select</option>

                    {unitData?.map((data, index) => (
                      <option key={index} value={data.common_unit}>
                        {data.common_unit}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 mt">
                  <label>Sub Unit Quantity</label>
                  <input
                    type="text"
                    className="form-control"
                    name="subUnitQty"
                    onChange={(e) => handleChangeInputBase(e)}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: "none" }}>
              <Button variant="success" onClick={handleUpdateBase}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            show={co2Modal}
            onHide={handleCloseCo2Modal}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h5 className="mb-0">
                  {t("add")} {t("CO2 Information")}
                </h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-md-6 mt">
                  {" "}
                  <label>CO2 Unit</label>
                  <select
                    className="form-control"
                    name="co2_unt_measure"
                    onChange={(e) => handleChangeInput(e)}
                  >
                    <option value="">Select</option>

                    {unitData?.map((data, index) => (
                      <option key={index} value={data.common_unit}>
                        {data.common_unit}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 mt">
                  <label>CO2 Unit Quantity</label>
                  <input
                    type="text"
                    className="form-control"
                    name="co2_qty"
                    onChange={(e) => handleChangeInput(e)}
                  />
                </div>
                <div className="col-md-6 mt">
                  <label>KGCO2 per CO2 Unit</label>
                  <input
                    type="text"
                    className="form-control"
                    name="kgco2_co2_unit"
                    onChange={(e) => handleChangeInput(e)}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: "none" }}>
              <Button variant="success" onClick={handleUpdateCo2}>
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          {/* <Modal
            size="lg"
            show={purchaseModal}
            onHide={() => setPurchaseModal(false)}
            dialogClassName="custom-modal-size"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h4 className="mb-3">{t("purchaseHistory")}</h4>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("Invoice ID")}</th>
                      <th>{t("Order Date")}</th>
                      <th>{t("User")}</th>
                      <th>{t("Purchase Quantity")}</th>
                      <th>{t("Price")}</th>
                      <th>{t("Change Percentage")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {purchaseHistory?.length > 0 &&
                      purchaseHistory
                        ?.sort(
                          (a, b) =>
                            new Date(b?.createdAt) - new Date(a?.createdAt)
                        )
                        ?.map((item) => {
                          return (
                            <tr key={item.id}>
                              <td data-label="Order ID">
                                <Link to="javascript:void(0)">
                                  {item.orderId}
                                </Link>
                              </td>
                              <td data-label="Order Date">
                                <Link to="javascript:void(0)">
                                  {moment(item.createdAt).format("DD-MM-YYYY")}
                                </Link>
                              </td>
                              <td data-label="Order Date">
                                <Link to="javascript:void(0)">
                                  {`${item?.User?.firstName} ${item?.User?.lastName}`}
                                </Link>
                              </td>
                              <td data-label="Total Quantity per Base units">
                                <Link to="javascript:void(0)">
                                  {item.totalQuantityPerBaseUnits}
                                </Link>
                              </td>
                              <td data-label="Base unit Price">
                                <Link to="javascript:void(0)">
                                  {item.currencyType}{" "}
                                  {currencyFormatter
                                    .format(item.baseUnitPrice, {
                                      code: "ISK",
                                    })
                                    .replace("kr.", "")
                                    .trim()}
                                </Link>
                              </td>
                              <td data-label="Change Percentage">
                                <Link to="javascript:void(0)">
                                  {item?.changePercentage
                                    ? `${Number(item?.changePercentage).toFixed(
                                        2
                                      )} %`
                                    : "----"}
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                  </tbody>
                </table>
              </div>
            </Modal.Body>
          </Modal> */}

          <Modal
            size="lg"
            show={showPurchaseModal}
            onHide={() => setShowPurchaseModal(false)}
            dialogClassName="custom-modal-size"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h4 className="mb-3">{t("purchaseHistory")}</h4>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("orderId")}</th>
                      <th>{t("Order Date")}</th>
                      <th>{t("User")}</th>
                      <th>{t("productNumber")}</th>
                      <th>{t("productName")}</th>
                      <th>{t("Purchase Quantity")}</th>
                      <th>{t("co2_qty")}</th>
                      <th>{t("kgco2")}</th>
                      <th>{t("Price")}</th>
                      <th>{t("Change Percentage")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {selectedProductDetails?.PurchaseHistories?.length > 0 &&
                      selectedProductDetails?.PurchaseHistories?.sort(
                        (a, b) =>
                          new Date(b?.createdAt) - new Date(a?.createdAt)
                      )?.map((item) => {
                        return (
                          <tr key={item.id} className="">
                            <td data-label="Order ID">
                              <Link
                                to={`/pastorderedit?id=${selectedPastOrderDetails.id}&invoiceId=${selectedInvoiceId}`}
                                target="_blank"
                                className="text-primary"
                                title="View Order Details"
                              >
                                <i className="fa-solid fa-up-right-from-square me-1"></i>
                                {selectedProductDetails?.pastOrder?.id}
                              </Link>
                            </td>
                            <td data-label="Order Date">
                              {moment(item.createdAt).format("DD-MM-YYYY")}
                            </td>
                            <td data-label="User Name">
                              {`${item?.User?.firstName} ${item?.User?.lastName}`}
                            </td>
                            <td data-label="Product Number">
                              <Link
                                to={`/productdetails?id=${selectedProductDetails.id}`}
                                target="_blank"
                                className="text-primary"
                                title="View Order Details"
                              >
                                {`${selectedProductDetails?.number}`}
                              </Link>
                            </td>
                            <td data-label="Product Name">
                              {`${selectedProductDetails.name}`}
                            </td>
                            <td data-label="Total Quantity per Base units">
                              {item.totalQuantityPerBaseUnits}
                            </td>
                            <td data-label="CO2e">
                              {selectedProductDetails?.co2_qty}
                            </td>
                            <td data-label="KgCO2e">
                              {selectedProductDetails?.kgco2_co2_unit}
                            </td>
                            <td data-label="Base unit Price">
                              {item.currencyType}{" "}
                              {currencyFormatter
                                .format(item.saleUnit, {
                                  code: "ISK",
                                })
                                .replace("kr.", "")
                                .trim()}
                            </td>
                            <td data-label="Change In Percentage">
                              {item?.changePercentage
                                ? `${Number(item?.changePercentage).toFixed(
                                    2
                                  )} %`
                                : ""}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            size="lg"
            show={logs}
            onHide={handleCloseLogs}
            dialogClassName="custom-modal-size"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h4 className="mb-3">{t("allLogs")}</h4>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("Date and Time")}</th>
                      <th>{t("User")}</th>
                      <th>{t("Discount")}</th>
                      <th>{t("CO2 unit Quantity")}</th>
                      <th>{t("KgCO2 per CO2 unit")}</th>
                      <th>{t("Manufacturer prod. number")}</th>
                      <th>{t("Manufacturer name")}</th>
                      <th>{t("Manufacturer Country of Origin")}</th>
                      <th>{t("Gross weight")}</th>
                      <th>{t("Dry weight")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {allLogs
                        ?.sort(
                          (a, b) =>
                            new Date(b.createdAt) - new Date(a.createdAt)
                        )
                        ?.map((s) => (
                          <tr className={isActive ? null : "inactive"}>
                            <td data-label="Date and Time">
                              {moment(s?.createdAt).format(
                                "DD-MM-YYYY,HH:mm:ss"
                              )}
                            </td>
                            <td data-label="Order Date">
                              <Link to="javascript:void(0)">
                                {`${s?.User?.firstName} ${s?.User?.lastName}`}
                              </Link>
                            </td>

                            <td data-label="Question">{s?.discount}</td>
                            <td data-label="Answer">{s?.co2_qty}&nbsp;</td>
                            <td data-label="Answer">
                              {s?.kgco2_co2_unit}&nbsp;
                            </td>
                            <td data-label="Answer">
                              {s?.manufactureProductNumber}&nbsp;
                            </td>
                            <td data-label="Answer">
                              {s?.manufactureName}&nbsp;
                            </td>
                            <td data-label="Answer">
                              {s?.manufactureCountry}&nbsp;
                            </td>
                            <td data-label="Answer">{s?.gross_weight}&nbsp;</td>
                            <td data-label="Answer">{s?.net_weight}&nbsp;</td>
                          </tr>
                        ))}
                    </>
                  </tbody>
                </table>
              </div>
            </Modal.Body>
          </Modal>
          <div className="commonBase">
            <div className="dbtableTop mb-3 poSrch ponew">
              <div className="dbSearch">
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("search")}
                  onChange={onSearch}
                  value={search}
                />
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
              <div className="dbtableSrchbg">
                <button className="tglbtn" onClick={handleToggle}>
                  {isToggled ? (
                    <i className="fa-light fa-grid-2"></i>
                  ) : (
                    <i className="fa-solid fa-list"></i>
                  )}
                </button>{" "}
                &nbsp; &nbsp;
                {activeTab === "tab2" && (
                  <button
                    className="commonButton"
                    disabled={!selected.length}
                    onClick={(e) => onUnspc(e)}
                  >
                    <i className="fa-solid fa-plus"></i> {t("add")} UNSPSC
                  </button>
                )}
                &nbsp;
                {activeTab === "tab2" && (
                  <button
                    className="commonButton"
                    disabled={!selected.length}
                    onClick={(e) => onBaseUnit(e)}
                  >
                    <i className="fa-solid fa-plus"></i> {t("add")} Base Unit
                    Information
                  </button>
                )}{" "}
                &nbsp;
                {activeTab === "tab3" && (
                  <button
                    className="commonButton"
                    disabled={!selectedCO2.length}
                    onClick={() => setCO2Modal(true)}
                  >
                    <i className="fa-solid fa-plus"></i> {t("add")}{" "}
                    {t("CO2 Information")}
                  </button>
                )}
                &nbsp;
                <button className="commonButton" onClick={_RESET}>
                  {t("reset")}
                </button>
              </div>
            </div>
            <div className="dbtableTop prdtt">
              <div className="swtch"></div>
              <div className="dbtableSrchbg srchResp">
                <div className="dateSelect">
                  <DatePicker
                    selectsStart
                    selected={startDate}
                    onChange={onFromDate}
                    placeholderText={t("from")}
                    dateFormat="yyyy-MM-dd"
                  />
                  &nbsp;&nbsp;
                  <DatePicker
                    selectsEnd
                    selected={endDate}
                    onChange={onToDate}
                    endDate={endDate}
                    startDate={startDate}
                    minDate={startDate}
                    placeholderText={t("to")}
                  />
                </div>
                &nbsp;&nbsp;
                <Multiselect
                  onSuppliers={onSuppliers}
                  options={invoiceSupplierDataList?.map(
                    (item) => item.AccountingSupplierParty
                  )}
                  type={"Suppliers"}
                  selectedOptions={selectedOptions}
                  setSelectedOptions={setSelectedOptions}
                />
                &nbsp;&nbsp;
                <select className="form-control" onChange={onMonth}>
                  <option selected={month === ""} value="">
                    {t("Select Month")}
                  </option>
                  <option>1</option>
                  <option>3</option>
                  <option>6</option>
                  <option>9</option>
                  <option>12</option>
                </select>
              </div>
            </div>

            {isToggled && (
              <>
                <Tabs
                  defaultActiveKey="tab1"
                  id="my-tabs"
                  className="supplyerTablink"
                  activeKey={activeTab}
                  onSelect={handleTabSelect}
                >
                  <Tab eventKey="tab1" title={t("General Product Information")}>
                    <div className="dbMaintable">
                      <table>
                        <thead>
                          <tr>
                            {generalProductColumn.map((col) => (
                              <th>{col.label}</th>
                            ))}
                            <th>{t("purchaseHistory")}</th>
                            <th>{t("Logs")}</th>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                          </tr>
                        </thead>
                        {isLoading && (
                          <SpinnerComponent isLoading={isLoading} />
                        )}
                        <tbody>
                          {generalTableData
                            ?.slice(offset, offset + PER_PAGE)
                            ?.map((d) => (
                              <tr className={d?.isActive ? null : "inactive"}>
                                <td>
                                  <Link
                                    to={`/supplierdetailsinfo?id=${d?.supplierId}`}
                                    style={{ color: "rgb(13, 110, 253)" }}
                                  >
                                    {d?.supplierName}
                                  </Link>
                                </td>
                                <td>
                                  <Link to="javascript:void(0)">
                                    {d?.productNumber}
                                  </Link>
                                </td>
                                <td>
                                  <Link
                                    to={`/productdetails?id=${d?.id}`}
                                    style={{ color: "rgb(13, 110, 253)" }}
                                  >
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip
                                          id="tooltip"
                                          style={{ fontSize: "10px" }}
                                        >
                                          {d?.productName}
                                        </Tooltip>
                                      }
                                    >
                                      <span>
                                        {`${d?.productName?.slice(0, 10)}${
                                          d?.productName?.length > 10
                                            ? "..."
                                            : ""
                                        }`}
                                      </span>
                                    </OverlayTrigger>
                                  </Link>
                                </td>
                                {d?.UNSPSC ? (
                                  <td
                                    className="text-center"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip
                                          id="tooltip"
                                          style={{ fontSize: "10px" }}
                                        >
                                          {d?.UNSPSC}
                                        </Tooltip>
                                      }
                                    >
                                      <Button
                                        variant="success"
                                        className="unspsc"
                                      >
                                        {`${(d?.UNSPSC).slice(0, 10)}${
                                          (d?.UNSPSC).length > 10 ? "..." : ""
                                        }`}
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                ) : (
                                  <td
                                    className="text-center"
                                    style={{ fontSize: "16px" }}
                                  >
                                    ....
                                  </td>
                                )}
                                <td>
                                  ISK{" "}
                                  {currencyFormatter
                                    .format(d?.listPrice, {
                                      code: "ISK",
                                    })
                                    .replace("kr.", "")
                                    .trim()}
                                  {/* {d?.listPrice
                                    ? Number(d?.listPrice).toFixed(2)
                                    : "----"} */}
                                </td>
                                <td>
                                  <Link to="javascript:void(0)">
                                    {d?.discount ? d?.discount + "%" : "----"}
                                  </Link>
                                </td>
                                <td>
                                  {/* {d?.listPrice
                                    ? getPurchasePrice(
                                        d?.listPrice,
                                        d?.discount
                                      )
                                    : "----"} */}
                                  ISK{" "}
                                  {currencyFormatter
                                    .format(
                                      d?.listPrice
                                        ? getPurchasePrice(
                                            d?.listPrice,
                                            d?.discount
                                          )
                                        : "",
                                      {
                                        code: "ISK",
                                      }
                                    )
                                    .replace("kr.", "")
                                    .trim()}
                                </td>
                                <td>
                                  <Link to="javascript:void(0)">
                                    {d?.baseUnit ? d?.baseUnit : "----"}
                                  </Link>
                                </td>
                                <td>
                                  <Link to="javascript:void(0)">
                                    {/* {d?.purchasePriceBase} */}
                                    ISK{" "}
                                    {d?.purchasePriceBase > 999
                                      ? currencyFormatter
                                          .format(d?.purchasePriceBase, {
                                            code: "ISK",
                                          })
                                          .replace("kr.", "")
                                          .trim()
                                      : d?.purchasePriceBase}
                                    {/* {
                                      currencyFormatter
                                      .format(d?.purchasePriceBase, {
                                        code: "ISK",
                                      })
                                      .replace("kr.", "")
                                      .trim()} */}
                                  </Link>
                                </td>
                                <td>
                                  <Link to="javascript:void(0)">
                                    {d?.kgco2_co2_unit
                                      ? d?.kgco2_co2_unit
                                      : "----"}
                                  </Link>
                                </td>

                                <td>{d?.productUpdatedAt}</td>
                                <td data-label="Logs">
                                  <Link
                                    onClick={() =>
                                      getPurchaseHistoryByProductId(d?.id)
                                    }
                                  >
                                    <i
                                      className={`fa-solid fa-clock ${
                                        d?.PurchaseHistories?.[
                                          d?.PurchaseHistories.length - 1
                                        ]?.changePercentage > 0
                                          ? "text-danger"
                                          : "text-success"
                                      }`}
                                    ></i>
                                  </Link>
                                </td>
                                <td data-label="Logs">
                                  <Link onClick={(e) => onLogs(e, d?.id)}>
                                    <i
                                      className="fa fa-history"
                                      aria-hidden="true"
                                    ></i>
                                  </Link>
                                </td>
                                <td>
                                  <button
                                    onClick={() =>
                                      handleActive(d?.id, d?.isActive)
                                    }
                                    className="beye"
                                  >
                                    <i className="fa-light fa-eye"></i>
                                    <i className="fa-light fa-eye-slash"></i>
                                  </button>
                                  &nbsp;&nbsp;
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </Tab>

                  <Tab
                    eventKey="tab2"
                    title={t("Units and UNSPSC Information")}
                  >
                    <div className="dbMaintable">
                      <table>
                        <thead>
                          <tr>
                            <th>
                              {!isToggleddata && (
                                <input
                                  type="checkbox"
                                  checked={selectedAll}
                                  onChange={(e) => selectAll(e)}
                                />
                              )}
                            </th>
                            {UNSPSCColumn.map((col) => (
                              <th>{col.label}</th>
                            ))}
                            <th>{t("purchaseHistory")}</th>
                            <th>{t("Logs")}</th>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                          </tr>
                        </thead>
                        {!currentPageData.length && (
                          <SpinnerComponent
                            isLoading={!currentPageData.length}
                          />
                        )}
                        {isLoading && (
                          <SpinnerComponent isLoading={isLoading} />
                        )}
                        <tbody>
                          {UNSPSCTableData?.slice(
                            offset,
                            offset + PER_PAGE
                          )?.map((d, index) => (
                            <tr className={d?.isActive ? null : "inactive"}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selected.some(
                                    (item) => item.id === d.id
                                  )}
                                  onClick={() => onUNSPSCCheck(d)}
                                />
                              </td>
                              <td>
                                <Link
                                  to={`/supplierdetailsinfo?id=${d.supplierId}`}
                                  style={{ color: "rgb(13, 110, 253)" }}
                                >
                                  {d?.supplierName}
                                </Link>
                              </td>
                              <td>
                                <Link to="javascript:void(0)">
                                  {d?.productNumber}
                                </Link>
                              </td>
                              <td>
                                <Link
                                  to={`/productdetails?id=${d?.id}`}
                                  style={{ color: "rgb(13, 110, 253)" }}
                                >
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip
                                        id="tooltip"
                                        style={{ fontSize: "10px" }}
                                      >
                                        {d?.productName}
                                      </Tooltip>
                                    }
                                  >
                                    <span>
                                      {`${(d?.productName).slice(0, 10)}${
                                        (d?.productName).length > 10
                                          ? "..."
                                          : ""
                                      }`}
                                    </span>
                                  </OverlayTrigger>
                                </Link>
                              </td>

                              <td>
                                {d?.sale_unit_of_measure
                                  ? d?.sale_unit_of_measure
                                  : "----"}
                              </td>
                              <td>
                                {d?.base_unit_of_measure
                                  ? d?.base_unit_of_measure
                                  : "----"}
                              </td>
                              <td>
                                {d?.baseUnitPrice
                                  ? Number(d?.baseUnitPrice).toFixed(2)
                                  : "----"}
                              </td>
                              <td>
                                {d?.sub_unit_of_measure
                                  ? d?.sub_unit_of_measure
                                  : "----"}
                              </td>
                              <td>
                                {d?.subUnitQty &&
                                !isNaN(d?.subUnitQty) &&
                                d?.subUnitQty !== ""
                                  ? Number(d?.subUnitQty).toFixed(2)
                                  : "-"}
                              </td>
                              {d?.UNSPSC ? (
                                <td
                                  className="text-center"
                                  style={{ fontSize: "16px" }}
                                  onClick={(e) => onUnspc(e, d, index)}
                                >
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip
                                        id="tooltip"
                                        style={{ fontSize: "10px" }}
                                      >
                                        {d?.UNSPSC}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      variant="success"
                                      className="unspsc"
                                    >
                                      {`${(d?.UNSPSC).slice(0, 10)}${
                                        (d?.UNSPSC).length > 10 ? "..." : ""
                                      }`}
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                              ) : (
                                <td
                                  className="text-center"
                                  style={{ fontSize: "16px" }}
                                >
                                  <Link
                                    to={"javascript:void(0)"}
                                    onClick={(e) => onUnspc(e, d)}
                                  >
                                    <i className="fa-regular fa-circle-plus"></i>
                                  </Link>
                                </td>
                              )}
                              <td data-label="Logs">
                                <Link
                                  onClick={() =>
                                    getPurchaseHistoryByProductId(d?.id)
                                  }
                                >
                                  <i
                                    className={`fa-solid fa-clock ${
                                      d?.PurchaseHistories?.[
                                        d?.PurchaseHistories.length - 1
                                      ]?.changePercentage > 0
                                        ? "text-danger"
                                        : "text-success"
                                    }`}
                                  ></i>
                                </Link>
                              </td>
                              <td data-label="Logs">
                                <Link onClick={(e) => onLogs(e, d?.id)}>
                                  <i
                                    className="fa fa-history"
                                    aria-hidden="true"
                                  ></i>
                                </Link>
                              </td>

                              <td>
                                <button
                                  onClick={() =>
                                    handleActive(d?.id, d?.isActive)
                                  }
                                  className="beye"
                                >
                                  <i className="fa-light fa-eye"></i>
                                  <i className="fa-light fa-eye-slash"></i>
                                </button>
                                &nbsp;&nbsp;
                                <i className="fa-light fa-eye-slash"></i>
                              </td>

                              <td> &nbsp;&nbsp;</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Tab>

                  <Tab eventKey="tab3" title={t("CO2e Information")}>
                    <div className="dbMaintable">
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                checked={selectedCO2All}
                                onChange={(e) => onCO2CheckAll(e)}
                              />
                            </th>
                            {CO2Column.map((col) => (
                              <th>{col.label}</th>
                            ))}
                            <th>{t("purchaseHistory")}</th>
                            <th>{t("logs")}</th>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                          </tr>
                        </thead>
                        {!currentPageData.length && (
                          <SpinnerComponent
                            isLoading={!currentPageData.length}
                          />
                        )}
                        {isLoading && (
                          <SpinnerComponent isLoading={isLoading} />
                        )}
                        <tbody>
                          {CO2TableData?.slice(offset, offset + PER_PAGE)?.map(
                            (d) => (
                              <tr className={d?.isActive ? null : "inactive"}>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedCO2.includes(d?.id)}
                                    onChange={() => onCO2Check(d?.id)}
                                  />
                                </td>
                                <td>
                                  <Link
                                    to={`/supplierdetailsinfo?id=${d.supplierId}`}
                                    style={{ color: "rgb(13, 110, 253)" }}
                                  >
                                    {d?.supplierName}
                                  </Link>
                                </td>
                                <td>
                                  <Link to="javascript:void(0)">
                                    {d?.productNumber}
                                  </Link>
                                </td>
                                <td>
                                  <Link
                                    to={`/productdetails?id=${d?.id}`}
                                    style={{ color: "rgb(13, 110, 253)" }}
                                  >
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip
                                          id="tooltip"
                                          style={{ fontSize: "10px" }}
                                        >
                                          {d?.productName}
                                        </Tooltip>
                                      }
                                    >
                                      <span>
                                        {`${d?.productName?.slice(0, 10)}${
                                          d?.productName?.length > 10
                                            ? "..."
                                            : ""
                                        }`}
                                      </span>
                                    </OverlayTrigger>
                                  </Link>
                                </td>

                                <td>
                                  {d?.co2_unt_measure
                                    ? d?.co2_unt_measure
                                    : "----"}
                                </td>
                                <td>
                                  {d?.co2_qty
                                    ? Number(d?.co2_qty).toFixed(2)
                                    : "----"}
                                </td>
                                <td>
                                  {d?.kgco2_co2_unit
                                    ? d?.kgco2_co2_unit
                                    : "----"}
                                </td>
                                <td>
                                  {d?.KgCO2_per_Sale_unit
                                    ? d?.KgCO2_per_Sale_unit
                                    : "----"}
                                </td>
                                <td>
                                  {d?.manufactureName
                                    ? d?.manufactureName
                                    : "----"}
                                </td>
                                <td>
                                  {d?.manufactureProductNumber
                                    ? d?.manufactureProductNumber
                                    : "----"}
                                </td>
                                <td>
                                  <select
                                    className="countryDropdown"
                                    onChange={(e) =>
                                      handleCountry(e.target.value, d?.id)
                                    }
                                  >
                                    <option value="">Country</option>
                                    {countryData?.map((data) => (
                                      <option
                                        value={data?.isoCode}
                                        selected={d?.country === data?.isoCode}
                                      >
                                        {data?.name}
                                      </option>
                                    ))}
                                  </select>
                                </td>
                                <td data-label="Logs">
                                  <Link
                                    onClick={() =>
                                      getPurchaseHistoryByProductId(d?.id)
                                    }
                                  >
                                    <i
                                      className={`fa-solid fa-clock ${
                                        d?.PurchaseHistories?.[
                                          d?.PurchaseHistories.length - 1
                                        ]?.changePercentage > 0
                                          ? "text-danger"
                                          : "text-success"
                                      }`}
                                    ></i>
                                  </Link>
                                </td>
                                <td data-label="Logs">
                                  <Link onClick={(e) => onLogs(e, d?.id)}>
                                    <i
                                      className="fa fa-history"
                                      aria-hidden="true"
                                    ></i>
                                  </Link>
                                </td>
                                <td>
                                  <button
                                    onClick={() =>
                                      handleActive(d?.id, d?.isActive)
                                    }
                                    className="beye"
                                  >
                                    <i className="fa-light fa-eye"></i>
                                    <i className="fa-light fa-eye-slash"></i>
                                  </button>
                                  &nbsp;&nbsp;
                                </td>
                                <td> &nbsp;&nbsp;</td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Tab>
                </Tabs>

                {!isLoading && (
                  <ReactPaginate
                    previousLabel={t("previous")}
                    nextLabel={t("next")}
                    pageCount={pageCount}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"pagination__link"}
                    nextLinkClassName={"pagination__link"}
                    disabledClassName={"pagination__link--disabled"}
                    activeClassName={"pagination__link--active"}
                    forcePage={currentPage}
                  />
                )}
              </>
            )}
            {!isToggled && (
              <div className="productGrid">
                {getProductId?.map((d) => (
                  <Card>
                    <Card.Body>
                      <div className="gridBlock gridTools">
                        &nbsp;
                        <span>
                          <button
                            onClick={() => handleActive(d?.id, d?.isActive)}
                            className="beye"
                          >
                            <i className="fa-light fa-eye"></i>
                            <i className="fa-light fa-eye-slash"></i>
                          </button>
                          &nbsp;&nbsp;
                          <Link to="/">
                            <i className="fa-light fa-pen"></i>
                          </Link>
                          &nbsp;&nbsp;
                          <i className="fa-light fa-eye-slash"></i>
                        </span>
                      </div>

                      <div className={d?.isActive ? null : "inactive"}>
                        <div className="gridBlock">
                          <p>
                            {t("Number")}: <span>{d?.number}</span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("Name")}: <span>{d?.name}</span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("Supplier Short Name")}:{" "}
                            <span>{d?.supplierShortName}</span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("UNSPSC")}: <span>{d?.unspsc}</span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("Base unit")}:{" "}
                            <span>
                              {d?.item?.Price?.BaseQuantity?._text}{" "}
                              {
                                d?.item?.Price?.BaseQuantity?._attributes
                                  ?.unitCode
                              }
                            </span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("Base unit price")}:{" "}
                            <span>{Number(d?.baseUnitPrice).toFixed(2)}</span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("Sale unit")}: <span>--</span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("Sale unit price")}: <span>--</span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("CO2 units")}: <span>--</span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("Discount")}: <span>--%</span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("Purchase price")}:{" "}
                            <span>{Number(d?.purchasePrice).toFixed(2)}</span>
                          </p>
                        </div>
                        <div className="gridBlock">
                          <p>
                            {t("Last modified date")}: {d?.productUpdatedAt}
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal size="lg" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>Purchase History</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="prdviewTable">
            <table>
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Order Date</th>
                  <th>Total Quantity per Base units</th>
                  <th>Base unit Price</th>
                  <th>Sale Unit</th>
                  <th>% Difference in Sale unit price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2121514</td>
                  <td>20-10-2023</td>
                  <td>30</td>
                  <td>Íkr 1500</td>
                  <td>Íkr 1800</td>
                  <td>5%</td>
                </tr>
                <tr>
                  <td>2121514</td>
                  <td>20-10-2023</td>
                  <td>30</td>
                  <td>Íkr 1500</td>
                  <td>Íkr 1800</td>
                  <td>5%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="lg" show={showUnspc} onHide={handleCloseUnspc} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="mb-0">{t("add")} UNSPSC</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="dbMaintable productMainScroll">
            {search && <>Total results: {searchResults.length}</>}

            <div className="searchParentDiv">
              <div>
                <input
                  className="productSearch py-2 px-4"
                  type="search"
                  placeholder="Type something to search..."
                  onChange={(e) => searchUnspsc(e.target.value)}
                />
              </div>
              {search && (
                <div className="searchResults">
                  {searchResults && searchResults.length > 0 ? (
                    <>
                      {searchResults.map((result, index) => (
                        <div
                          className="form-check d-flex justify-content-between"
                          key={index}
                          onClick={() => getUnspscData(result)}
                        >
                          <div>
                            {index +
                              1 +
                              ". " +
                              result.value +
                              " (" +
                              result.belongsTo +
                              " " +
                              result.key +
                              ")"}
                          </div>
                          <div>
                            <i
                              className="fa fa-plus theme-color"
                              aria-hidden="true"
                              title="Click to Add"
                            ></i>
                          </div>
                        </div>
                      ))}

                      {/* Load More Button */}
                      {totalSearchResult > searchResults.length && (
                        <div className="load-more d-flex justify-content-center">
                          {isSearchLoading ? (
                            <button disabled>
                              <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                            </button>
                          ) : (
                            !searchResultsEnd && (
                              <button onClick={loadMoreResults}>
                                Load More
                              </button>
                            )
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="form-check" style={{ textAlign: "center" }}>
                      {isSearchLoading ? (
                        <i className="fa-solid fa-spinner fa-spin"></i>
                      ) : (
                        "No Result Found"
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            <h2 className="d-flex justify-content-center">{t("OR")}</h2>
            <h5 className="mt-4 mb-3">UNSPSC :</h5>
            <div className="accordion unspscAccord" id="unAccordion">
              <div className="accordion-item">
                {segmentDataList
                  .sort((a, b) => a?.Segment - b?.Segment)
                  ?.map((segment) => (
                    <TreeItem
                      key={segment.Segment}
                      title={t("segment_code", {
                        segment: segment.Segment,
                        title: segment.SegmentTitle,
                      })}
                      isOpen={openSegment === segment.Segment}
                      toggleOpen={() => handleSegmentClick(segment.Segment)}
                      onClick={onDataSegment.bind(
                        segment?.Segment,
                        `${segment?.Segment}`
                      )}
                    >
                      {allUnspcFamily?.map((family) => (
                        <TreeItem
                          key={family.Family}
                          title={t("family_code", {
                            family: family.Family,
                            title: family.FamilyTitle,
                          })}
                          isOpen={openFamily === family.Family}
                          toggleOpen={() =>
                            handleFamilyClick(segment.Segment, family.Family)
                          }
                          onClick={onDataFamily.bind(
                            family?.Family,
                            `${family?.Family}`
                          )}
                        >
                          {allUnspcClass?.map((classItem) => (
                            <TreeItem
                              key={classItem.Class}
                              title={t("class_code", {
                                class: classItem.Class,
                                title: classItem.ClassTitle,
                              })}
                              isOpen={openClass === classItem.Class}
                              toggleOpen={() =>
                                handleClassClick(family.Family, classItem.Class)
                              }
                              onClick={onDataClass.bind(
                                classItem?.Class,
                                `${classItem?.Class}`
                              )}
                            >
                              {allUnspcComodity?.map((commodity) => (
                                <TreeItem
                                  key={commodity.Commodity}
                                  title={t("commodity_code", {
                                    commodity: commodity.Commodity,
                                    title: commodity.CommodityTitle,
                                  })}
                                />
                              ))}
                            </TreeItem>
                          ))}
                        </TreeItem>
                      ))}
                    </TreeItem>
                  ))}
              </div>
            </div>
          </div>

          <div className="d-flex">
            <button className="commonButton ms-auto p-2" onClick={searchPage}>
              {t("View More")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Products;
